// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"3caba457","703":"41a59f14"}[chunkId] + ".chunk.js";
};